var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallEnergyDrink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#small-energy-drink_svg__clip0)",
    fill: "#91C300",
    stroke: "#91C300",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.656 2.391V.937c0-.259-.21-.468-.468-.468H5.063c-.26 0-.47.21-.47.469V2.39A2.348 2.348 0 002.72 4.687v20.625c0 .77.378 1.448.952 1.875h-.015v1.875c0 .26.21.47.469.47h15c.26 0 .469-.21.469-.47v-1.875h-.015a2.335 2.335 0 00.952-1.875V4.688a2.348 2.348 0 00-1.875-2.296zm-.937-.985v.938H5.53v-.938H17.72zM5.062 3.281h13.125c.776 0 1.407.631 1.407 1.406v.47H3.656v-.47c0-.775.631-1.406 1.406-1.406zm14.532 2.813v17.812H3.656V6.094h15.938zm-.938 22.5H4.594v-.985c.151.03.308.047.468.047h13.125c.16 0 .318-.016.47-.047v.985zm-.468-1.875H5.063a1.408 1.408 0 01-1.407-1.407v-.468h15.938v.468c0 .776-.631 1.407-1.407 1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.417 15.806h0c.108.146.278.232.458.232h1.93L7.825 20.39a.569.569 0 00.92.637l7.031-7.031a.569.569 0 00-.402-.971h-2.688l2.224-3.334h0a.569.569 0 00-.473-.885H9.75c-.25 0-.47.163-.544.402 0 0 0 0 0 0l-1.875 6.094h0a.57.57 0 00.086.505zm3.27-.906H8.646l1.525-4.956h3.205l-2.223 3.334h0a.57.57 0 00.473.884h2.377l-3.843 3.843 1.046-2.3s0 0 0 0a.57.57 0 00-.04-.543h0a.569.569 0 00-.477-.262z",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "small-energy-drink_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.375)",
    d: "M0 0h22v30H0z"
  })))));
}

export default SvgSmallEnergyDrink;